export const PACKAGE_ALERTS_PATH = '/home/reception/packagealerts';
